export const LOCALES = [
  // English
  { code: "en-US", name: "English (United States)" },
  { code: "en-CA", name: "English (Canada)" },
  { code: "en-GB", name: "English (United Kingdom)" },
  { code: "en-AU", name: "English (Australia)" },
  { code: "en-NZ", name: "English (New Zealand)" },
  { code: "en-SG", name: "English (Singapore)" },

  // French
  { code: "fr-FR", name: "French (France)" },
  { code: "fr-CA", name: "French (Canada)" },

  // Spanish & Portuguese
  { code: "es-ES", name: "Spanish (Spain)" },
  { code: "es-MX", name: "Spanish (Mexico)" },
  { code: "es-AR", name: "Spanish (Argentina)" },
  { code: "pt-PT", name: "Portuguese (Portugal)" },
  { code: "pt-BR", name: "Portuguese (Brazil)" },

  // Western Europe
  { code: "de-DE", name: "German (Germany)" },
  { code: "it-IT", name: "Italian (Italy)" },
  { code: "nl-NL", name: "Dutch (Netherlands)" },
  { code: "sv-SE", name: "Swedish (Sweden)" },
  { code: "da-DK", name: "Danish (Denmark)" },
  { code: "fi-FI", name: "Finnish (Finland)" },
  { code: "no-NO", name: "Norwegian (Norway)" },

  // Central / Eastern Europe
  { code: "pl-PL", name: "Polish (Poland)" },
  { code: "cs-CZ", name: "Czech (Czech Republic)" },
  { code: "hu-HU", name: "Hungarian (Hungary)" },
  { code: "ro-RO", name: "Romanian (Romania)" },
  { code: "ru-RU", name: "Russian (Russia)" },

  // Asia
  { code: "zh-CN", name: "Chinese (Simplified)" },
  { code: "zh-TW", name: "Chinese (Traditional)" },
  { code: "ja-JP", name: "Japanese (Japan)" },
  { code: "ko-KR", name: "Korean (South Korea)" },
  { code: "th-TH", name: "Thai (Thailand)" },
  { code: "vi-VN", name: "Vietnamese (Vietnam)" },

  // South Asia
  { code: "hi-IN", name: "Hindi (India)" },
  { code: "ur-PK", name: "Urdu (Pakistan)" },
  { code: "bn-BD", name: "Bengali (Bangladesh)" },

  // Middle East
  { code: "ar-SA", name: "Arabic (Saudi Arabia)" },
  { code: "ar-AE", name: "Arabic (United Arab Emirates)" },
  { code: "he-IL", name: "Hebrew (Israel)" },
];
